import { useDirectorActions, useDirectorContext } from "@contexts/director";
import QualityBanner from "../QualityBanner";

const EMPTY_QUALITY_SOURCES = [];

const ModuleShell = ({
  eyebrow,
  title,
  description,
  badge,
  children,
  className = "",
  qualitySources = EMPTY_QUALITY_SOURCES,
  showProjectFilter = true,
}) => {
  const {
    selectedCompanyId,
    accessByCompany,
    metadata = {},
    filters = {},
  } = useDirectorContext();
  const actions = useDirectorActions();
  const access = accessByCompany[selectedCompanyId] || {};
  const projects = metadata.projects || [];
  return <main className={`director-page director-module1 ${className}`.trim()}>
    <header className="director-page__header director-module1__header">
      <div>
        <span className="director-eyebrow">{eyebrow || `Diretoria · ${access.companyName || "portfólio"}`}</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="director-module1__header-actions">
        {badge && <span className="director-module1__badge">{badge}</span>}
        {Object.keys(accessByCompany).length > 1 && <label className="director-filter-field">
          <span>Empresa</span>
          <select value={selectedCompanyId || ""} onChange={(event) => actions?.selectCompany(event.target.value)}>
            {Object.entries(accessByCompany).map(([id, item]) => <option key={id} value={id}>
              {item.companyName}
            </option>)}
          </select>
        </label>}
        {showProjectFilter && projects.length > 1 && <label className="director-filter-field">
          <span>Obra</span>
          <select
            value={filters.projectKey || ""}
            onChange={(event) => actions?.setFilters({
              legalEntityId: null,
              projectKey: event.target.value || null,
              costCenterId: null,
            })}
          >
            <option value="">Portfólio consolidado</option>
            {projects.map((project) => <option key={project.key} value={project.key}>
              {project.name}
            </option>)}
          </select>
        </label>}
      </div>
    </header>
    <QualityBanner sources={qualitySources} />
    {children}
  </main>;
};

export default ModuleShell;
